import "babel-polyfill";
import Vue from 'vue'
import axios from 'axios'
import counsel from './counsel.vue'
import promotionCounsel from './counsel_promotion.vue'
import creatIVExpPacakage from './creative_exp_package.vue'
import promotionCounselNoPopup from './counsel_promotion_no_popup.vue'
import letter from './letter.vue'
import letterOld from './letter_old.vue'

Vue.prototype.$http = axios;

if(location.href.indexOf('promotion.html') < 0) {
    new Vue({
        el: '#counsel',
        render: h => h(counsel)
    });
}

if(location.href.indexOf('promotion.html') > -1) {
    new Vue({
        el: '#promotionCounsel',
        render: h => h(promotionCounsel)
    });
}

if(location.href.indexOf('creative_exp_package.html') > -1) {
    new Vue({
        el: '#creative-exp-package',
        render: h => h(creatIVExpPacakage)
    });
}

if(location.href.indexOf('promotion.html') > -1) {
    new Vue({
        el: '#promotionCounselNoPopup',
        render: h => h(promotionCounselNoPopup)
    });


    new Vue({
        el: '#letterOld',
        render: h => h(letterOld)
    });

}

new Vue({
    el: '#letter',
    render: h => h(letter)
});



// WEBPACK FOOTER //
// ./src/main.js